// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__sH2T9","right":"Footer_right__1lv28","buttons":"Footer_buttons__348cb"};